import * as D from './deps';

export function getAdList(content) {
  return D.Api.apiRequest({
    endpoint: D.ApiEndpoints.GET_ADLIST,
    method: 'post',
    content,
  });
}

export function fetchADSData(content) {
  return D.Api.apiRequest({
    endpoint: D.ApiEndpoints.ADS_DISPLAY_AD,
    method: 'post',
    content,
    retries: 1,
  });
}

export function fetchUID(content) {
  return D.Api.apiRequest({
    endpoint: D.ApiEndpoints.FETCH_UID,
    method: 'post',
    content,
  });
}
